import { faEye, faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import './ReportTable.scss';

interface ReportTableProps {
  id: string,
  data: any[][],
  onOpenLink: (link: string, download: boolean) => void,
  darkMode: boolean
};

const ReportTable = (props: ReportTableProps) => {
  return (
    <div className='report-table-wrapper'>
      <table className={'table-' + (props.darkMode ? 'dark' : 'light')}>
        <thead className='table-header'>
          <tr>
            <th style={{fontSize: 'var(--sidenav-icon-font)'}}>Date</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {props.data.map((r, idx_r) =>
            <tr key={props.id + '_report_row_' + idx_r} style={{ fontWeight: 700 }}>
              {r.map((elem, idx_c) => {
                let content = elem;
                switch (idx_c) {
                  case 1:
                    content = <FontAwesomeIcon
                      icon={faFileExcel}
                      className='icon green'
                      onClick={() => props.onOpenLink(elem, true)}
                    />
                    break;
                  case 2:
                    content = <FontAwesomeIcon
                      icon={faFilePdf}
                      className='icon red'
                      onClick={() => props.onOpenLink(elem, true)}
                    />
                    break;
                  case 3:
                    content = <FontAwesomeIcon
                      icon={faEye}
                      className='icon grey'
                      onClick={() => props.onOpenLink(elem, false)}
                    />
                }
                return (
                  <td
                    key={props.id + '_report_row_' + idx_r + '_col_' + idx_c}
                    style={{
                      textAlign: 'start',
                      fontSize: idx_c === 0 ? 'var(--sidenav-icon-font)' : 'var(--paragraph-font)'
                    }}
                  >
                    {content}
                  </td>
                );
              })}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReportTable;